import { Box, useTheme } from '@mui/material';
import Button from '@mui/material/Button';

import { Breadcrumbs } from '~components/layout/header/bread-crumbs/bread-crumbs';
import { breadcrumbsRoutes } from '~components/layout/header/bread-crumbs/bread-crumbs.routes';
import { HeaderContainer } from '~components/layout/header/header.styles';
import { UserHeaderBadge } from '~components/layout/header/user-header-badge/user-header-badge';
import { AppIcon } from '~components/shared/app-icon/app-icon';
import { Logo } from '~components/ui/logo/logo';
import { AppTypography } from '~components/ui/typography/app-typography';

import { useAppBack } from '~hooks/use-app-back';
import { useMobileMenu } from '~hooks/use-mobile-menu';

import { ReactComponent as IconArrowLeft } from '~assets/icons/icon-arrow-left-lg.svg';
import { ReactComponent as IconBurgerMenu } from '~assets/icons/icon-burger-menu.svg';
import { ReactComponent as IconClose } from '~assets/icons/icon-close.svg';

export const Header = () => {
  const goBack = useAppBack();
  const theme = useTheme();
  const { toggleMenu, isMenuOpen } = useMobileMenu();

  return (
    <HeaderContainer>
      <Box display={{ md: 'none' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: 'primary.100',
            backgroundColor: 'primary.10',
            borderRadius: theme.spacing(0.5),
            padding: theme.spacing(0.5, 1),
            cursor: 'pointer',
          }}
          onClick={toggleMenu}
          role={'button'}
        >
          <AppIcon component={isMenuOpen ? IconClose : IconBurgerMenu} />
          <AppTypography size={'body-md'} weight={'bold'}>
            {isMenuOpen ? 'Сховати' : 'Меню'}
          </AppTypography>
        </Box>
      </Box>

      <Box sx={{ position: 'relative', top: 3, display: { md: 'none' } }}>
        <Logo width={82} />
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'none',
          [theme.breakpoints.up('md')]: {
            display: 'flex',
            // alignItems: 'flex-start',
            gap: theme.spacing(1.5),
          },
        }}
      >
        <Button
          variant={'outlined'}
          size={'large'}
          startIcon={<AppIcon component={IconArrowLeft} />}
          sx={{ maxHeight: 44 }}
          onClick={goBack}
        >
          Назад
        </Button>
        <Breadcrumbs routes={breadcrumbsRoutes} />
      </Box>

      <UserHeaderBadge />
    </HeaderContainer>
  );
};
